import React, { useState } from 'react';

function ChatModal({ chat, onClose, onSendReply, onRegenerateResponse }) {
  const [message, setMessage] = useState(chat.aiResponse || '');
  const [isRegenerating, setIsRegenerating] = useState(false);

  const handleSend = () => {
    if (!message.trim()) {
      alert('답변 내용을 입력해주세요.');
      return;
    }
    onSendReply(chat.id, message);
  };

  const handleRegenerate = async () => {
    setIsRegenerating(true);
    try {
      const newResponse = await onRegenerateResponse(chat.message);
      if (newResponse) {
        setMessage(newResponse);
      }
    } finally {
      setIsRegenerating(false);
    }
  };

  return (
    <div className="modal active">
      <div className="modal-content modal-large">
        <div className="modal-header">
          <h3 className="modal-title">채팅 상세</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {/* 고객 메시지 */}
          <div className="chat-section">
            <h4 className="section-title">고객 메시지</h4>
            <div className="message-box customer-message">
              <div className="message-header">
                <span className="sender-name">{chat.senderName}</span>
                <span className="message-time">{new Date(chat.timestamp).toLocaleString('ko-KR')}</span>
              </div>
              <p className="message-text">{chat.message}</p>
            </div>
          </div>

          {/* AI 답변 */}
          <div className="chat-section">
            <div className="section-header">
              <h4 className="section-title">답변</h4>
              <button
                className="btn btn-small btn-outline"
                onClick={handleRegenerate}
                disabled={isRegenerating}
              >
                {isRegenerating ? '생성 중...' : '답변 재생성'}
              </button>
            </div>
            <textarea
              className="form-textarea"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={8}
              placeholder="답변 내용을 입력하거나 수정하세요..."
            />
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            취소
          </button>
          <button className="btn btn-primary" onClick={handleSend}>
            답변 전송
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChatModal;
